<template>
  <div class="app-mail-simple_ams" :class="{ [curTheme]: true }">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`mail-group-${i}`"
        class="input-group"
        @click="removeError(i)">

        <div class="aml_block-wrap">

          <div class="aml_block aml_block--mail">
            <el-autocomplete
              clearable
              :class="{ 'child-has-error': error[i] }"
              v-model="valueLocal[i]"
              :trigger-on-focus="false"
              @select="onSelect"
              :fetch-suggestions="fetchSuggestions"
              class="ams_input"/>
          </div>

        </div>

        <div
          v-if="error[i]"
          class="ait_message ait_message--error">
          {{ error[i] }}
        </div>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import approve from 'approvejs';
import Common from './mixins/Common';

export default {

  mixins: [Common],

  created() {
    // Add error messages
    this.validateMessages = Object.assign(
      this.validateMessages, {
        email: 'Введите корректный адрес электронной почты!',
      },
    );
  },

  computed: {

    domains() {
      const orgs = this.$store.getters['orgs/getOrgs'];
      const domains = [];
      orgs.forEach((org) => {
        org.MailDomains.forEach((domain) => {
          domains.push({ value: domain });
        });
      });
      return domains;
    },

  },

  methods: {

    onSelect() {
      window.AppMailAuthJustSelected = true;
    },

    fetchSuggestions(query, cb) {
      const [namePt, domainPt] = query.split('@');
      if (domainPt && domainPt.length > 0) {
        const domainsFiltered = this.domains
          .filter(domain => domain.value.indexOf(domainPt) === 0)
          .map(domain => ({ value: `${namePt}@${domain.value}` }));
        if (domainsFiltered.length > 1 || (domainsFiltered.length === 1
          && domainsFiltered[0].value.split('@')[1].length > domainPt.length)
        ) {
          cb(domainsFiltered);
          return;
        }
      }
      cb([]);
    },

    getError() {
      // Validate required
      if (this.options.required) {
        this.valueLocal.forEach((value, i) => {
          const result = approve.value(value, { required: true });
          this.error[i] = result.approved ? '' : this.validateMessages.required;
        });
      }
      // Validate email
      this.valueLocal.forEach((value, i) => {
        if (this.error[i]) return;
        const result = approve.value(value, { email: true });
        this.error[i] = result.approved ? '' : this.validateMessages.email;
      });
      this.updateValue();
      return this.error;
    },

  },

};
</script>

<style lang="scss">
@import '../../../styles/common/main';

.app-mail-simple_ams {
  .ams_input {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppMailSimple.vue